import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { RolePermissions, ResCode } from './baseDefine';




/**
 * 获取自己的状态信息返回
 *
 * @interface UserInfoResponse
 */
export interface UserInfoResponse {
  code: ResCode;
  msg: string;
  data: Data;
}

/**
 * http 返回的data
 *
 * @export
 * @interface Data
 */
export interface Data {
  userInfo: UserInfo;
}

/**
 *  user基本信息
 *
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
  name: string;
  phone: string;
  email: string;
  position: string;
  portrait: string;
  roleInfo: RoleInfo;
  companyName: string;
  postion: string;
  id: number;
  frontRole: string;
  language: string;
  companyLogo: string;
  companyMessageDate: number;
  companyPaymentDate: number;
  zone: string;
}


/**
 * 所属的角色信息包含前端和后端
 *
 * @export
 * @interface RoleInfo
 */
export interface RoleInfo {
  root: boolean;                        // 是否root用户
  frontPermissions: RolePermissions;
  backendPrmissions: RolePermissions;
}





/**
 * 获取自己的信息
 *
 * @export
 * @returns {AxiosPromise<UserInfoResponse>}
 */
export function getSelfInfo(): Promise<UserInfoResponse> {
  return request.post<UserInfoResponse>('/admin/auth/getUserInfo');
}
